import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RunReportResponse } from '@api/types/case/case-report/run-report.response';
import { ReportType } from '@api/types/report-type/report-type.option';
import { ReportSubType } from '@api/types/report-type/report-subtype.option';
import { ReportRankBy } from '@api/types/report-type/report-rank-by.option';

export interface RunReportModel {
  reportTypeId: number;
  reportTypeName: string;
  reportType: ReportType;
  reportSubTypeId: number;
  reportSubTypeName: string;
  reportSubType: ReportSubType;
  reportRankById: number;
  reportRankByName: string;
  reportRankBy: ReportRankBy;
  ids?: number[];
  caseImpactTypeId?: number;
  impactGroup?: string;
  impactType?: string;
}

interface ReportsSliceState {
  openLensesSlideOut: boolean;
  isRcaHelpSlideOutOpen: boolean;
  showId?: number;
  model?: RunReportModel;
  data?: RunReportResponse<any>;
  shrinkView: boolean;
  selectedRankRow?: number;
}

const initialState: ReportsSliceState = {
  openLensesSlideOut: false,
  isRcaHelpSlideOutOpen: false,
  showId: undefined,
  model: undefined,
  data: undefined,
  shrinkView: false,
  selectedRankRow: undefined,
};

const reportSlice = createSlice({
  name: 'reportSlice',
  initialState: initialState,
  reducers: {
    setShowReportId(
      state,
      { payload: { id, reset } }: PayloadAction<{ id: number; reset: boolean }>
    ) {
      return {
        ...(reset ? initialState : state),
        showId: id,
      };
    },
    setShowRunModel(
      state,
      {
        payload: { model, reset },
      }: PayloadAction<{ model: RunReportModel; reset: boolean }>
    ) {
      return {
        ...(reset ? initialState : state),
        model,
      };
    },
    setLoadedReportData(
      state,
      {
        payload,
      }: PayloadAction<{
        model: RunReportModel;
        data: RunReportResponse<any>;
      }>
    ) {
      state.model = payload.model;
      state.data = payload.data;
    },
    closeReport(state, _: PayloadAction) {
      return {
        ...initialState,
      };
    },
    toggleShrinkView(state, _: PayloadAction) {
      state.shrinkView = !state.shrinkView;
    },
    setOpenLensesSlideOut(state, { payload }: PayloadAction<boolean>) {
      state.openLensesSlideOut = payload;
    },
    setIsRCAHelpSlideOutOpen(state, { payload }: PayloadAction<boolean>) {
      console.log(state.isRcaHelpSlideOutOpen);
      state.isRcaHelpSlideOutOpen = payload;
      console.log(state.isRcaHelpSlideOutOpen);
    },
    setSelectedRankRow(state, { payload }: PayloadAction<number>) {
      state.selectedRankRow = payload;
    },
  },
});

export const {
  setShowReportId,
  setShowRunModel,
  setLoadedReportData,
  closeReport,
  toggleShrinkView,
  setOpenLensesSlideOut,
  setIsRCAHelpSlideOutOpen,
  setSelectedRankRow,
} = reportSlice.actions;

export default reportSlice.reducer;
